import { render, staticRenderFns } from "./carbonOverview.vue?vue&type=template&id=3c071aba&scoped=true&"
import script from "./carbonOverview.vue?vue&type=script&lang=js&"
export * from "./carbonOverview.vue?vue&type=script&lang=js&"
import style0 from "./carbonOverview.vue?vue&type=style&index=0&id=3c071aba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c071aba",
  null
  
)

export default component.exports